import { render, staticRenderFns } from "./EventosTabelaSuporte.vue?vue&type=template&id=93d6da98"
import script from "./EventosTabelaSuporte.vue?vue&type=script&lang=ts"
export * from "./EventosTabelaSuporte.vue?vue&type=script&lang=ts"
import style0 from "./EventosTabelaSuporte.vue?vue&type=style&index=0&id=93d6da98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports